<template>
  <section class="content">
    <!-- Cabecera -->
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Categorías</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
              <li class="breadcrumb-item active">Categorías</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <div class="container-fluid">
      <!-- Switch de vista -->
      <div class="row mb-2">
        <div class="col-12 col-sm-6 col-md-4">
          <div id="btn-agregar-categoria" class="info-box mb-3" data-toggle="modal" data-target="#categoriaModal"
            @click="nuevaCategoria()">
            <a href="javascript:void(0)" class="btn btn-block info-box-icon bg-info elevation-1"><i class="fas fa-plus"></i></a>
            <div class="info-box-content">
              <span class="info-box-text">Categoria</span>
              <span class="info-box-number">Agregar</span>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-md-4">
          <div id="btn-descargar-pdf" class="info-box mb-3" @click="descargarPDF()" style="cursor: pointer;">
            <a href="javascript:void(0)" class="btn btn-block info-box-icon bg-danger elevation-1">
              <i class="fas fa-file-pdf"></i>
            </a>
            <div class="info-box-content">
              <span class="info-box-text">Reporte</span>
              <span class="info-box-number">Descargar PDF</span>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="card">

            <!-- Header -->
            <div class="card-header">
              <h3 class="card-title">
                Lista de categorías que puedes administrar
              </h3>
            </div>

            <!-- Body: Tabla o Cards -->
            <div class="card-body">
              <!-- VISTA TABLA -->
              <div class="table-responsive">
                <table class="table table-bordered table-striped w-100" id="tablaCategoria">
                  <thead>
                    <tr>
                      <th>Código</th>
                      <th>Descripción</th>
                      <th>Proveedor</th>
                      <th>Opciones</th>
                    </tr>
                  </thead>
                  <tbody></tbody>
                </table>
              </div>

              <!-- Formulario en Modal -->
              <formCategorias :proveedores="proveedores" :categoria="categoriaActual" @success="obtenerCategorias" />
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { ref, onMounted, onBeforeUnmount, nextTick, getCurrentInstance } from "vue";
import api from "@/services/api";
import 'datatables.net-bs4';
import FormCategorias from "@/components/FormCategorias.vue";
import { loading } from '@/plugins/loading';
import { alert } from '@/plugins/alert';
import { tutorial } from "@/plugins/tutorial";

export default {
  components: { FormCategorias },

  setup() {
    const { proxy } = getCurrentInstance();
    const dt = ref(null);
    const categorias = ref([]);
    const proveedores = ref([]);
    const categoriaActual = ref(null);

    async function obtenerCategorias() {
      const { data } = await api.get("/categoria");
      categorias.value = data;
      await nextTick();

      if (!dt.value && window.$ && $.fn.DataTable) {
        dt.value = window.$(`#tablaCategoria`).DataTable({
          data: categorias.value,
          columns: [
            { data: "codigo" },
            { data: "descripcion" },
            { data: "proveedor.descripcion", defaultContent: "" },
            {
              data: null,
              orderable: false,
              className: "text-center",
              render: (data, type, row) => `
                <button class="btn btn-warning btn-sm editar" data-id="${row.id}">
                  <i class="fas fa-pen-to-square"></i>
                </button>
                <button class="btn btn-danger btn-sm eliminar ms-1" data-id="${row.id}">
                  <i class="fas fa-trash"></i>
                </button>
              `
            }
          ],
          responsive: true,
          autoWidth: false,
          pageLength: 10,
          lengthChange: false,
          pagingType: 'numbers',
          language: {
            url: 'https://cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json'
          },
          dom:
            '<"row mb-3"<"col-12 col-md-6"f>>' +
            't' +
            '<"row mt-3"<"col-12 text-center"i>>' +
            '<"row"<"col-12 d-flex justify-content-center"p>>',
        });

        window.$("#tablaCategoria tbody")
          .on("click", "button.editar", function () {
            const id = window.$(this).data("id");
            const cat = categorias.value.find(c => c.id === id);
            editarCategoria(cat);
          })
          .on("click", "button.eliminar", function () {
            const id = window.$(this).data("id");
            const cat = categorias.value.find(c => c.id === id);
            confirmarBorrado(cat);
          });

      } else if (dt.value) {
        dt.value.clear().rows.add(categorias.value).draw();
      }
    }

    async function obtenerProveedores() {
      const response = await api.get("/proveedor");
      proveedores.value = response.data;
    }

    function confirmarBorrado(categoria) {
      proxy.$alert({
        title: '¿Seguro?',
        text: `No podrás revertir la eliminación de "${categoria.descripcion}"`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, bórralo'
      }).then(res => {
        if (res.isConfirmed) {
          eliminarCategoria(categoria.id);
        }
      });
    }

    async function eliminarCategoria(id) {
      try {
        loading.show('Eliminando...');
        await api.delete(`/categoria/${id}`);
        loading.hide();
        proxy.$toast({ icon: 'success', title: '¡Categoría eliminada!' });
        await obtenerCategorias();
      } catch (error) {
        loading.hide();
        console.error("Error al eliminar categoría:", error);
        
        const mensajeServidor = error.response?.data?.message || 'Error al eliminar la categoría';
        const detallesServidor = error.response?.data?.detalles || 'Ocurrió un error inesperado en el servidor.';
        proxy.$toast({ icon: 'error', title: mensajeServidor, text: detallesServidor });
      }
    }

    async function descargarPDF() {
      try {
        loading.show('Generando PDF...');
        const response = await api.get("/pdf/categorias", { responseType: 'blob' });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Reporte_Categorias.pdf');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        loading.hide();
      } catch (error) {
        loading.hide();
        alert.show({ title: 'Error', text: 'No se pudo generar el PDF', icon: 'error' });
      }
    }

    function nuevaCategoria() {
      categoriaActual.value = null;
    }

    function editarCategoria(categoria) {
      categoriaActual.value = { ...categoria };
      nextTick(() => {
        window.$('#categoriaModal').modal('show');
      });
    }

    function iniciarTutorial() {
      const steps = [
        {
          element: '#btn-agregar-categoria',
          title: 'Nueva Categoría',
          text: 'Haz clic aquí para registrar una nueva categoría.',
          position: 'bottom'
        },
        {
          element: '#btn-descargar-pdf',
          title: 'Descargar Reporte',
          text: 'Haz clic aquí para generar y descargar un listado de todas las categorías en formato PDF.',
          position: 'bottom'
        },
        {
          element: '.card-body',
          title: 'Listado de Categorías',
          text: 'Aquí verás la lista de categorías registradas.',
          position: 'top'
        }
      ];

      const table = window.$('#tablaCategoria');
      const isCollapsed = table.hasClass('collapsed');
      const actionsVisible = table.find('tbody tr:first-child td:last-child').is(':visible');

      if (isCollapsed && !actionsVisible) {
        const firstRow = table.find('tbody tr:first-child');

        if (firstRow.hasClass('parent')) {
          const control = firstRow.find('.dtr-control');
          if (control.length) control.click();
          else firstRow.find('td:first-child').click();
        }

        steps.push({
          element: '#tablaCategoria tbody tr:first-child td:first-child',
          title: 'Ver Detalles',
          text: 'En pantallas pequeñas, haz clic en el símbolo (+) para ver los datos ocultos y las acciones.',
          position: 'bottom',
          tooltipClass: 'hide-next-btn'
        });

        firstRow.off('click.tutorial');
        firstRow.on('click.tutorial', function () {
          setTimeout(() => {
            const tooltip = document.querySelector('.introjs-tooltip');
            if (!tooltip) return;
            if (window.$(this).hasClass('parent')) {
              tooltip.classList.remove('hide-next-btn');
            } else {
              tooltip.classList.add('hide-next-btn');
            }
          }, 200);
        });

        steps.push({
          element: '.dtr-details .editar',
          title: 'Editar Categoría',
          text: 'Haz clic en el botón amarillo para modificar los datos de una categoría.',
          position: 'left'
        }, {
          element: '.dtr-details .eliminar',
          title: 'Eliminar Categoría',
          text: 'Haz clic en el botón rojo para eliminar una categoría.',
          position: 'left'
        });
      } else {
        steps.push({
          element: '.editar',
          title: 'Editar Categoría',
          text: 'Haz clic en el botón amarillo para modificar los datos de una categoría.',
          position: 'left'
        }, {
          element: '.eliminar',
          title: 'Eliminar Categoría',
          text: 'Haz clic en el botón rojo para eliminar una categoría.',
          position: 'left'
        });
      }

      tutorial.start(steps);
    }

    onMounted(() => {
      obtenerProveedores();
      obtenerCategorias();
      tutorial.set(iniciarTutorial);
    });

    onBeforeUnmount(() => {
      if (dt.value) {
        window.$("#tablaCategoria tbody").off("click");
        dt.value.destroy();
        dt.value = null;
      }
      tutorial.set(null);
    });

    return { proveedores, categoriaActual, nuevaCategoria, editarCategoria, obtenerCategorias, confirmarBorrado, obtenerProveedores, categorias, descargarPDF };
  }
};
</script>
<style>
.hide-next-btn .introjs-nextbutton,
.hide-next-btn .introjs-nextBtn {
  display: none !important;
}
</style>